import dayjs from 'dayjs';

import { apiClientMethods } from 'src/api/client';

const AUTH_TOKEN = 'AUTH_TOKEN';
const AUTH_TOKEN_EXPIRY = 'AUTH_TOKEN_EXPIRY';
const SESSION_MINUTES = 60;

/**
 * Persist an authenticated token the way the ?api_key= boot path does: set the
 * axios X-API-Key header + the localStorage token and a 60-minute expiry
 * (without an expiry the session-timeout interceptor logs out immediately).
 */
export function applyAuthToken(token: string): void {
  apiClientMethods.setToken(token);
  localStorage.setItem(AUTH_TOKEN, token);
  localStorage.setItem(
    AUTH_TOKEN_EXPIRY,
    dayjs().add(SESSION_MINUTES, 'minutes').toISOString()
  );
}

/**
 * Full reload to '/' so UserStoreProvider re-runs GET property_user/ and
 * establishes the citizen session from the freshly persisted token.
 */
export function redirectToPortalHome(): void {
  window.location.assign('/');
}
